module.exports = __webpack_public_path__ + "media/images/flags/16/Western-Sahara-cc58e08f8db6a6e19beed91f117e91f8.png";